import { takeEvery, put, call } from 'redux-saga/effects';
import { tournamentsApi } from '../api/tournaments';
import { createTournament, cancelTournament, createBlindStructure, updateBlindStructure } from '../slices/tournaments';

function* handleCancelTournament(action: any) {
  const { tournamentId } = action.payload;
  const onSuccess = action.payload?.meta?.onSuccess;

  try {
    // Dispatch the RTK Query mutation
    const mutationPromise = yield put(tournamentsApi.endpoints.cancelTournament.initiate(action.payload));

    // Wait for the promise to resolve and unwrap the result
    yield call(() => mutationPromise.unwrap());

    console.log('Tournament cancelled successfully:', tournamentId);

    // Call onSuccess callback if provided
    if (typeof onSuccess === 'function') {
      yield call(onSuccess);
    }
  } catch (error) {
    console.error('Failed to cancel tournament:', tournamentId, error);
  }
}

function* handleCreateTournament(action: ReturnType<typeof createTournament>) {
  // Dispatch the RTK Query mutation
  yield put(tournamentsApi.endpoints.createTournament.initiate(action.payload));
}

function* handleUpdateBlindStructure(action: any) {
  // Dispatch the RTK Query mutation
  yield put(tournamentsApi.endpoints.updateBlindStructure.initiate(action.payload));
}

function* handleCreateBlindStructure(action: any) {
  yield put(tournamentsApi.endpoints.createBlindStructure.initiate(action.payload));
}

export function* tournamentsSaga() {
  yield takeEvery(cancelTournament, handleCancelTournament);
  yield takeEvery(createTournament, handleCreateTournament);
  yield takeEvery(updateBlindStructure, handleUpdateBlindStructure);
  yield takeEvery(createBlindStructure, handleCreateBlindStructure);
}
